import { z } from 'zod/v4';

const OkResponseRuntype = <T extends z.ZodTypeAny>(dataRuntype: T) =>
    z.object({
        result: z.literal('Ok'),
        data: dataRuntype,
    });

const ScriptErrorRuntype = z.object({
    result: z.literal('ScriptError'),
    data: z.object({}), //TODO: support full error types in the FE https://www.notion.so/luminovo/Support-full-error-types-in-the-FE-2de9777f465f4ab68cab55bc01729cd8
});

const UnknownIdentifierRuntype = z.object({
    result: z.literal('UnknownIdentifier'),
    data: z.string(),
});

export const CalculationResultNullValue = z.object({
    result: z.literal('NullValue'),
    data: z.string(),
});

const ErrorResponseRuntype = z.union([ScriptErrorRuntype, UnknownIdentifierRuntype, CalculationResultNullValue]);

export const CalculationResult = <T extends z.ZodTypeAny>(dataRuntype: T) =>
    ErrorResponseRuntype.or(OkResponseRuntype(dataRuntype));
